import smiley from "../../../assets/testimonialAssets/Frame 1.svg";
import star from "../../../assets/testimonialAssets/star.svg";
import "./testimonialList.css";

const TestimonialItem = (props) => {
  const { testimonialDetails } = props;
  const { name, standard, feedback } = testimonialDetails;

  return (
    <li className="testimonial-cards">
      <div className="name-standard-icon">
        <img src={smiley} alt="img" />
        <div className="name-standard">
          <h5 style={{ marginBottom: "0" }}>{name}</h5>
          <p>{standard}</p>
        </div>
      </div>
      <div style={{ display: "flex" }}>
        <img src={star} alt="rating" />
        <img src={star} alt="rating" />
        <img src={star} alt="rating" />
        <img src={star} alt="rating" />
      </div>
      <p className="testimonial-feedback">{feedback}</p>
    </li>
  );
};

export default TestimonialItem;
